import React from "react";
import { motion } from "framer-motion";
import { Search, Target, TrendingUp, Sparkles, RefreshCw, LifeBuoy } from "lucide-react";
import styles from "../sidequest.module.scss";

const benefits = [
  {
    icon: Search,
    title: "Keyword & ASO Tracking",
    description:
      "Monitor how your app ranks for the search terms that matter most, and see exactly where you can move up on the Meta Quest store.",
    featured: true,
  },
  {
    icon: Target,
    title: "Competitor Benchmarking",
    description: "See how your app stacks up against others in your category.",
  },
  {
    icon: TrendingUp,
    title: "Revenue Analytics",
    description: "Track downloads, reviews, and revenue trends at a glance.",
  },
  {
    icon: Sparkles,
    title: "AI-Powered Reports",
    description: "Predictive insights powered by KeyQuest's AI engine.",
  },
  {
    icon: RefreshCw,
    title: "Daily Updates",
    description: "Market data that refreshes automatically, every day.",
  },
  {
    icon: LifeBuoy,
    title: "Priority Partner Support",
    description: "Dedicated onboarding and support as a verified Sidequest developer.",
    banner: true,
  },
];

const Benefits = () => {
  return (
    <section className={`${styles.section} ${styles.benefitsSection}`} id="benefits">
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <span className={styles.badge}>What You Get</span>
          <h2>Everything you need to grow on Quest</h2>
          <p>
            Once verified, your account unlocks the same intelligence tools
            KeyQuest studios use to track and grow their apps.
          </p>
        </div>

        <div className={styles.benefitsBento}>
          {benefits.map((benefit, idx) => {
            const Icon = benefit.icon;
            const modifier = benefit.featured
              ? styles.benefitFeatured
              : benefit.banner
              ? styles.benefitBanner
              : "";
            return (
              <motion.div
                key={benefit.title}
                className={`${styles.benefitCard} ${modifier}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
              >
                <div className={styles.benefitIcon}>
                  <Icon size={benefit.featured ? 26 : 20} color="#ff2f6d" />
                </div>
                <div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
